import { Icon } from '@design-system';

export type AddNewRowProps = {
  label: string;
  onClick: () => void;
};

export const AddNewRow = ({ label, onClick }: AddNewRowProps) => (
  <button
    className="flex w-full flex-row items-center justify-between gap-3 rounded-sm border border-neutral-2 p-4 text-left"
    onClick={onClick}
    type="button"
  >
    <span>{label}</span>
    <Icon name="ic_add" size="sm" />
  </button>
);
